import type { FC } from "react";
import TimePicker from "react-time-picker";
import type { Value } from "react-time-picker/dist/cjs/shared/types";
import "./TimeRange.css";
import type { LocalTime } from "@js-joda/core";
import { useEventCallback } from "usehooks-ts";
import {
	fromTimePickerValue,
	toTimePickerValue,
} from "../helpers/timeConverter";

type Props = {
	value: [LocalTime | null, LocalTime | null];
	onChange: (value: [LocalTime | null, LocalTime | null]) => void;
};

export const TimeRange: FC<Readonly<Props>> = ({ value, onChange }) => {
	const [valueStart, valueEnd] = value;
	const looseStart = valueStart ? toTimePickerValue(valueStart) : undefined;
	const looseEnd = valueEnd ? toTimePickerValue(valueEnd) : undefined;

	const handleChange = useEventCallback(
		(index: 0 | 1, timeValue: Value | null) => {
			const newValue = [...value];
			newValue[index] = timeValue ? fromTimePickerValue(timeValue) : null;
			onChange(newValue as [LocalTime, LocalTime]);
		},
	);

	return (
		<div className="time-range">
			<TimePicker
				value={looseStart ?? undefined}
				onChange={(value) => handleChange(0, value)}
				disableClock
			/>
			<span>to</span>
			<TimePicker
				value={looseEnd ?? undefined}
				onChange={(value) => handleChange(1, value)}
				disableClock
			/>
		</div>
	);
};
